<template>
    <div class="Rewards" v-Loading="loading">
        <div class="rewards-con">
            <div class="img_rewards">{{lang == 'es'?'Bienestar':lang == 'zh_TW'?'獎勵':lang == 'en_ID'?'Insentif':'Rewards'}}</div>
<!--            <img class="img_rewards" src="@/assets/adoread/rewadrs/img_rewards.png"/>-->
            <div class="rewards-yue flexible f-csp">
                <div @click="$event.currentTarget.disabled ? '' : toreadfun(9)" v-preventReClick class="flexible aItem-center jc-center rewards-yue-item Coins-item mr20">
                    <img class="ic_coins" src="@/assets/adoread/rewadrs/ic_coins.png"/>
                    <span class="f26 ml24">{{lang == 'es'?'Coins':lang == 'zh_TW'?'書幣':lang == 'en_ID'?'Koin buku':'Coins'}}</span>
                    <span class="f30 ml5">{{checkInInfo.coin}}</span>
                    <img class="ic_more" src="@/assets/adoread/rewadrs/ic_more.png"/>
                </div>
                <div @click="$event.currentTarget.disabled ? '' : toreadfun(9)" v-preventReClick class="flexible aItem-center jc-center rewards-yue-item Bonus-item">
                    <img class="ic_coins" src="@/assets/adoread/rewadrs/img_bonus.png"/>
                    <span class="f26 ml24">{{lang == 'es'?'Bonus':lang == 'zh_TW'?'書券':lang == 'en_ID'?'Token buku':'Bonus'}}</span>
                    <span class="f30 ml5">{{checkInInfo.bonus}}</span>
                    <img class="ic_more" src="@/assets/adoread/rewadrs/ic_more.png"/>
                </div>
            </div>
            <div class="rewards-title f-fwb">{{lang == 'es'?'Check-in diario':lang == 'zh_TW'?'簽到':lang == 'en_ID'?'Check-in':'Check in'}}</div>
            <div class="rewards-list flexible flex-wrap">
                <div class="rewards-item"
                     v-for="(item) in checkInInfo.signList" :class="item.status==1?'Check-in-item':item.status==2?'Checked-item':item.status==4?'Recheck-item':item.status==5?'Recheck-in-item':'Wait-item'"
                     @click="$event.currentTarget.disabled ? '' : goCheck(item)" v-preventReClick
                ><!--Check-in-item-->
                    <div class="rewards-day f22 f-fwb">{{lang == 'es'?`DÍA${item.day}`:lang == 'zh_TW'?`第${item.day}天`:lang == 'en_ID'?`Hari ke-${item.day}`:`Day${item.day}`}}</div>
                    <div>
                        <img v-if="item.day==1||item.day==3||item.day==4||item.day==6" class="img_bonus mt10" src="@/assets/adoread/rewadrs/img_bonus.png"/>
                        <img v-if="item.day==2||item.day==5" class="ic_gift mt10" src="@/assets/adoread/rewadrs/ic_gift.png"/>
                        <img v-if="item.day==7" class="ic_bonus" src="@/assets/adoread/rewadrs/ic_bouns.png"/>
                    </div>
                    <div class="rewards-money">{{item.awardIntroduction}}</div>
                    <div class="rewards-status" v-if= "item.status==1">{{lang == 'es'?'Check-in diario':lang == 'zh_TW'?'簽到':lang == 'en_ID'?'Check-in':'Check in'}}</div>
                    <div class="rewards-status" v-else-if="item.status==2">{{lang == 'es'?'Terminado':lang == 'zh_TW'?'已簽到':lang == 'en_ID'?'Masuk':'Checked'}}</div>
                    <div class="rewards-status" v-else-if="item.status==4">{{lang == 'es'?'Resurrección':lang == 'zh_TW'?'重新簽到':lang == 'en_ID'?'Masuk kembali':'Recheck'}}</div>
                    <div class="rewards-status" v-else-if="item.status==5">{{lang == 'es'?'Comenzar de nuevo':lang == 'zh_TW'?'補簽':lang == 'en_ID'?'Periksa kembali':'Recheck in'}}</div>
                    <div class="rewards-status" v-else>{{lang == 'es'?'Esperar':lang == 'zh_TW'?'等待':lang == 'en_ID'?'Menunggu':'Wait'}}</div>
<!--                    <div class="rewards-status">{{item.status==1?'Check in':item.status==2?'Checked':item.status==4?'Recheck':item.status==5?'Recheck in':'Wait'}}</div>-->
                </div>
            </div>
            <div class="rewards-rules">
                <div class="rewards-rules-title flexible aItem-center f24">
                    <img src="@/assets/adoread/rewadrs/ic_rules.png"/>
                    {{lang == 'es'?'Reglas de check-in diario':lang == 'zh_TW'?'簽到規則':lang == 'en_ID'?'Peraturan Check-in':'Check-in rules'}}
                </div>
                <div class="rewards-rules-con f22 mt20" v-html="checkInInfo.ruleIntroduction">
                    {{checkInInfo.ruleIntroduction}}
                </div>
            </div>
        </div>
        <div class="daily-rewards">
            <div class="rewards-title f-fwb">{{lang == 'es'?'Recompensa diaria':lang == 'zh_TW'?'每日獎勵':lang == 'en_ID'?'Hadiah Harian':'Daily Reward'}}</div>
<!--            <div class="daily-rewards-all">-->
<!--                <img src="@/assets/adoread/rewadrs/img_1.png"/>-->
<!--                <div class="tip f30 f-fwb">Get 15 Bonus for fin</div>-->
<!--                <div class="amount">0/6</div>-->
<!--                <div class="rewards-btn Claimed">{{lang == 'es'?'Esperar':lang == 'zh_TW'?'等待':lang == 'en_ID'?'Menunggu':'WAIT'}}</div>-->
<!--            </div>-->
            <div class="daily-rewards-all" v-for="item in rewardlist" v-if="item.type==10">
                <div class="tip f30 f-fwb">{{item.desc}}</div>
                <div class="amount">{{item.attach}}/{{rewardlist.length - 1}}</div>
                <div class="rewards-btn Claimed" v-if="item.receiveInt == 3">{{lang == 'es'?'Esperar':lang == 'zh_TW'?'等待':lang == 'en_ID'?'Menunggu':'WAIT'}}</div>
                <div class="rewards-btn Claim" v-if="item.receiveInt == 2" @click="$event.currentTarget.disabled ? '' : torewardget(item.type)" v-preventReClick>{{lang == 'es'?'Disponible':lang == 'zh_TW'?'待領取':lang == 'en_ID'?'Go':'CLAIM'}}</div>
                <div class="rewards-btn Claimed" v-if="item.receiveInt == 1">{{lang == 'es'?'Terminado':lang == 'zh_TW'?'已領取':lang == 'en_ID'?'Mengumpulkan':'CLAIMED'}}</div>
            </div>
            <div class="taskList flexible flex-wrap">
                <div class="taskItem mt20" v-for="(item, index) in rewardlist" v-if="index < 6">
                    <div class="title f28 f-fwb">{{item.desc}}</div>
                    <div class="time f24 mt20" v-if="index <= 3">{{item.currentReadingTime}}/{{item.attach}}{{lang == 'es'?'minutos':lang == 'zh_TW'?'分鍾':lang == 'en_ID'?'menit':'mins'}}</div>
                    <div class="Bonus f24 mt20">
                        <i></i>
                        {{item.bonus}} {{lang == 'es'?'Bonus':lang == 'zh_TW'?'書券':lang == 'en_ID'?'Token buku':'Bonus'}}
                    </div>
                    <div class="task-img mt10">
                        <img v-if="index==0" class="img_t1" src="@/assets/adoread/rewadrs/img_t1@2x.png"/>
                        <img v-if="index==1" class="img_t2" src="@/assets/adoread/rewadrs/img_t2@2x.png"/>
                        <img v-if="index==2" class="img_t3" src="@/assets/adoread/rewadrs/img_t3@2x.png"/>
                        <img v-if="index==3" class="img_t4" src="@/assets/adoread/rewadrs/img_t4@2x.png"/>
                        <img v-if="index==4" class="img_t5" src="@/assets/adoread/rewadrs/img_t5@2x.png"/>
                        <img v-if="index==5" class="img_t6" src="@/assets/adoread/rewadrs/img_t6@2x.png"/>
                    </div>
                    <div class="rewards-btn toClaim" v-if="item.receiveInt == 3" @click="$event.currentTarget.disabled ? '' : toreadfun(item.type)" v-preventReClick>{{lang == 'es'?'Ir a Recoger':lang == 'zh_TW'?'去完成':lang == 'en_ID'?'Menyelesaikan':'TO CLAIM'}}</div>
                    <div class="rewards-btn Claim"
                         v-if="item.receiveInt == 2" @click="$event.currentTarget.disabled ? '' : torewardget(item.type)" v-preventReClick>{{lang == 'es'?'Disponible':lang == 'zh_TW'?'待領取':lang == 'en_ID'?'Go':'CLAIM'}}</div>
                    <div class="rewards-btn Claimed" v-if="item.receiveInt == 1">{{lang == 'es'?'Terminado':lang == 'zh_TW'?'已領取':lang == 'en_ID'?'Mengumpulkan':'CLAIMED'}}</div>
                </div>
            </div>
        </div>
        <div class="checkInPop" v-if="isSign">
            <div class="checkInPop-con">
                <img class="img_pop" src="@/assets/adoread/rewadrs/img_pop@2x.png"/>
                <div class="tip mt10 f30 f-tac">{{lang == 'es'?'Recompensas diarias de check-in':lang == 'zh_TW'?'獲取獎勵':lang == 'en_ID'?'Hadiah Check-in':'Check in Reward'}}</div>
                <div class="reward-amount f-tac f-fwb mt20">+{{getReward}}<span class="f30 ml5">{{lang == 'es'?'Bonus':lang == 'zh_TW'?'書券':lang == 'en_ID'?'Token buku':'Bonus'}}</span></div>
                <div class="got-btn" @click="$event.currentTarget.disabled ? '' : gotFinish(0)" v-preventReClick>
                    {{lang == 'es'?'Recibido':lang == 'zh_TW'?'領取':lang == 'en_ID'?'Menerima':'Get'}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Indicator } from 'mint-ui';
    import {signlist,signperiodic,signperiodicretroactive,rewardlist,rewardget} from '@/api/reward'
    import { getCookie } from "utils/core/kernel";
    export default {
        name: "",
        data: function () {
            return {
                isSign: false,
                checkInInfo: {},
                rewardlist: [],
                getReward: '',
                Claimtype: 1, // 1=签到；2=福利
                loading: true,
                lang: 'en_US'
            }
        },
        mounted() {
            // VConsole 默认会挂载到 `window.VConsole` 上
            // var vConsole = new window.VConsole();
            // console.log(vConsole);
            this.getsignlist()
            this.getrewardlist()
            var headers = JSON.parse(getCookie('headers'))
            this.lang = headers.lang
            console.log(this.lang)
        },

        methods: {
            /*签到列表*/
            getsignlist () {
                signlist().then(res=>{
                    this.checkInInfo =  res.data
                })
            },
            /*签到方法*/
            goCheck (item) {
                console.log(item.day)
                if (item.day == 7 && item.isToday && item.status == 3) {
                    this.Toast({
                        message: this.lang=='es'?"Debes comprobarlo recargando antes de recibirlo.":
                            this.lang == 'zh_TW'?'你需要通過充值重新簽到才能拿到':
                                this.lang == 'en_ID'?'Anda harus masuk kembali dengan melakukan isi ulang untuk mendapatkannya.':"You need to recheck through recharging before you get it.",
                        duration: 2000,
                        position: "center"
                    });
                } else {
                    if (item.status==2||item.status==3) {return false;}
                    if (item.status==1) {
                        this.Claimtype=1
                        signperiodic('').then(res=>{
                            console.log(res)
                            this.getReward = res.data
                            this.isHiddenBack(1)
                            this.isSign = true
                        })
                    } else if (item.status==5) {
                        this.Claimtype=1
                        signperiodicretroactive({retroactiveDay:item.day}).then(res=>{
                            console.log(res)
                            this.getReward = res.data
                            this.isHiddenBack(1)
                            this.isSign = true
                        })
                    } else if (item.status==4) {
                        const u = navigator.userAgent;
                        const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                        //android终端
                        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                        //ios终端
                        if (isAndroid) {
                            window.jsBridge.gorecharge(JSON.stringify({day: item.day, type: 'chongzhi'}))  //安卓
                        }
                        if (isiOS) {
                            window.webkit.messageHandlers.gorecharge.postMessage({day: item.day, type: 'chongzhi'}) // 苹果
                        }
                    }
                }
            },
            /*福利列表*/
            getrewardlist () {
                rewardlist().then(res=>{
                    this.loading = false
                    let readTime = getCookie('headers')?Number(JSON.parse(getCookie('headers')).readTime):0
                    console.log(readTime)
                    if (readTime < 15) {
                        res.data.list[0].currentReadingTime = readTime
                        res.data.list[1].currentReadingTime = readTime
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 15 && readTime < 30) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = readTime
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >=30 && readTime < 50) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 50 && readTime < 90) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        if (!res.data.list[2].receive) {
                            res.data.list[2].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = 50
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 90) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        if (!res.data.list[2].receive) {
                            res.data.list[2].receiveInt = 2
                        }
                        if (!res.data.list[3].receive) {
                            res.data.list[3].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = 50
                        res.data.list[3].currentReadingTime = 90
                    }
                    this.rewardlist = res.data.list
                })
            },
            /*去完成福利*/
            toreadfun (data) {
                let type = null
                if (data == 9) {
                    type = 'chongzhi'
                } else {
                    type = 'read'
                }
                const u = navigator.userAgent;
                const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                //ios终端
                if (isAndroid) {
                    window.jsBridge.gorecharge(JSON.stringify({type: type}))  //安卓
                }
                if (isiOS) {
                    window.webkit.messageHandlers.gorecharge.postMessage({type: type}) // 苹果
                }
            },
            /*获取福利*/
            torewardget(data) {
                this.Claimtype=2
                rewardget({type: data}).then(res=>{
                    console.log(res)
                    this.getReward = res.data
                    this.isHiddenBack(1)
                    this.isSign = true
                    this.checkInInfo.bonus = this.checkInInfo.bonus*1 + res.data*1
                })
            },
            gotFinish (data) {
                if (this.Claimtype==1) {
                    this.getsignlist()
                } else if (this.Claimtype==2) {
                    this.getrewardlist()
                }
                this.isHiddenBack(data)
                this.isSign = false
            },
            isHiddenBack (data) {
                const u = navigator.userAgent;
                const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                //ios终端
                if (isAndroid) {
                    window.jsBridge.gorecharge(JSON.stringify({type: 'showNavigationBack', isHiddenBack: data}))  //安卓
                }
                if (isiOS) {
                    window.webkit.messageHandlers.gorecharge.postMessage({type: 'showNavigationBack', isHiddenBack: data}) // 苹果
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .Rewards{
        letter-spacing: 0;
        background: #fff;
        padding-bottom: 30px;
        .rewards-con{
            background: #0D0E0F;
            border-radius:0 0 50px 50px;
        }
        .rewards-btn{
            width: 244px;
            height: 58px;
            border-radius: 29px;
            font-size: 26px;
            font-weight: bold;
            text-align: center;
            line-height: 58px;
            &.toClaim{
                background: linear-gradient(180deg, #FFF869 0%, #FFF300 100%);
                color: #000;
            }
            &.Claim{
                background: linear-gradient(180deg, #F415D2 0%, #E509A6 100%);
                color:#fff;
            }
            &.Claimed{
                background: linear-gradient(180deg, #757575 0%, #2A2A2A 100%);
                color: #fff;
            }
        }
        .img_rewards{
            display: inline-block;
            margin-left: 50px;
            margin-top: 30px;
            /*width: 250px;*/
            /*height: 70px;*/
            font-size: 60px;
            font-weight: bold;
            color:#fff;
        }
        .rewards-yue{
            margin-top: 30px;
            margin-left: 57px;
            .rewards-yue-item{
                width: 308px;
                height: 90px;
                border-radius: 46px;
                color: #fff;
                .ic_coins{
                    width: 50px;
                    height: 50px;
                }
                .ic_more{
                    width: 12px;
                    height: 20px;
                    margin-left: 4px;
                }
                &.Coins-item{
                    background: #6700FF;;
                }
                &.Bonus-item{
                    background: #212223;
                }
            }
        }
        .rewards-title{
            margin-top: 50px;
            margin-left: 30px;
            font-size: 46px;
            font-family: SimSun;
            color: #fff;
        }
        .rewards-list{
            margin-left: 30px;
            margin-top: 30px;
            .rewards-item{
                width: 158px;
                height: 192px;
                background: #444;
                border-radius: 18px;
                text-align: center;
                position: relative;
                margin-right: 20px;
                margin-bottom: 20px;
                .rewards-day{
                    margin-top: 16px;
                }
                img{
                    width: 48px;
                    height: 48px;
                    &.ic_bonus{
                        width: 130px;
                        height: 58px;
                    }
                }
                .rewards-money{
                    width: 150px;
                    height: 34px;
                    line-height: 36px;
                    background: #000000;
                    border-radius: 19px 19px 19px 0px;
                    font-size: 18px;
                    margin: auto;
                    white-space: nowrap;
                }
                .rewards-status{
                    position: absolute;
                    bottom: -1px;
                    width: 100%;
                    border-radius:0 0 18px 18px;
                    font-size: 18px;
                    height: 40px;
                    line-height: 40px;
                    z-index: 2;
                    margin-top: 5px;
                }
                &.Checked-item{
                    .rewards-status{
                        background: #686868;
                        color: #333333;
                    }
                }
                &.Recheck-item{
                    .rewards-status{
                        background: #6700FF;
                        color: #fff;
                    }
                }
                &.Recheck-in-item{
                    width: 154px;
                    border: 2px solid #6700FF;
                    background: linear-gradient(180deg, rgba(103,0,255,0) 0%, #6700FF 100%);;
                    .rewards-status{
                        background:  #6700FF;
                        color: #fff;
                    }
                    .rewards-money{
                        background: #333;
                        color: #ccc;
                    }
                    .rewards-day{
                        color: #ccc;
                    }
                }
                &.Wait-item{
                    background: linear-gradient(180deg, #ED0CB9 0%, #D70583 100%);
                    .rewards-day{
                        color: #fff;
                    }
                    .rewards-money{
                        background: #000;
                        color: #fff;
                    }
                    .rewards-status{
                        background: #212223;
                        color: #fff;
                    }
                }
                &.Check-in-item{
                    width: 154px;
                    border: 2px solid #E50AA6;
                    background: linear-gradient(180deg, rgba(71,71,71,0.12) 0%, #D70583 100%);
                    .rewards-money{
                        background: #000;
                        color: #fff;
                    }
                    .rewards-status{
                        background: #E50AA6;
                        color: #fff;
                    }
                }
                &:nth-child(7){
                    width: 336px;
                }
            }
        }
        .rewards-rules{
            padding: 0 10px 40px 30px;
            color: #fff;
            .rewards-rules-title{
                img{
                    width: 30px;
                    height: 30px;
                    margin-right: 5px;
                }
            }
            .rewards-rules-con{
                line-height: 42px;
                white-space: pre-wrap;
            }
        }
        .daily-rewards{
            margin-left: 30px;
            .rewards-title{
                margin-left: 0;
                color: #333333;
            }
            .daily-rewards-all{
                width: 690px;
                height: 318px;
                background: url('../../../assets/adoread/rewadrs/img_1.png') no-repeat;
                background-size: 690px;
                height: 318px;
                position: relative;
                margin-top: 30px;
                display: inline-block;
                /*img{*/
                /*    width: 690px;*/
                /*    height: 318px;*/
                /*    position: absolute;*/
                /*    z-index: 0;*/
                /*}*/
                .tip{
                    color: #fff;
                    margin-left: 40px;
                    margin-top: 40px;
                }
                .amount{
                    width: 122px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 23px 23px 23px 0px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 26px;
                    color: #6700FF;
                    font-weight: 500;
                    margin-left: 40px;
                    margin-top: 30px;
                }
                .rewards-btn{
                    margin-left: 40px;
                    margin-top: 90px;
                }
            }
        }
        .taskList{
            margin-bottom: 60px;
            .taskItem{
                width: 335px;
                height: 425px;
                background: #0D0E0F;
                border-radius: 12px;
                color: #fff;
                margin-right: 20px;
                position: relative;
                &:nth-child(2n){
                    margin-right:0px;
                }
                .title{
                    margin-top: 40px;
                    margin-left: 22px;
                }
                .time{
                    margin-left: 22px;
                    width: 170px;
                    height: 40px;
                    background: #6700FF;
                    border-radius: 23px 23px 23px 0px;
                    text-align: center;
                    line-height: 40px;
                }
                .Bonus{
                    width: 147px;
                    height: 40px;
                    background: #212223;
                    line-height: 40px;
                    margin-left: 22px;
                    position: relative;
                    text-align: center;
                    border-radius: 10px;
                    i{
                        position: absolute;
                        top: -8px;
                        left: 20px;
                        width: 0;
                        height: 0;
                        border-left: 5px solid transparent;
                        border-right: 5px solid transparent;
                        border-bottom: 8px solid #212223;
                    }
                }
                .task-img{
                    text-align: right;
                    .img_t1{
                        width: 162px;
                        height: 136px;
                        margin-right: 39px;
                    }
                    .img_t2{
                        width: 151px;
                        height: 130px;
                        margin-right: 25px;
                    }
                    .img_t3{
                        width: 164px;
                        height: 140px;
                        margin-right: 34px;
                    }
                    .img_t4{
                        width: 190px;
                        height: 128px;
                        margin-right: 24px;
                    }
                    .img_t5{
                        width: 204px;
                        height: 160px;
                        margin-right: 24px;
                    }
                    .img_t6{
                        width: 190px;
                        height: 180px;
                        margin-right: 58px;
                    }
                }
                .rewards-btn{
                    position: absolute;
                    left: 45px;
                    bottom: 16px;
                }
            }
        }
        .checkInPop{
            top: 0;
            position: fixed;
            width: 100%;
            height: 100%;
            background: #000;
            z-index: 2;
            .checkInPop-con{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                .img_pop{
                    width: 688px;
                    height: 436px;
                }
                .reward-amount{
                    font-size: 100px;
                }
                .got-btn{
                    width: 400px;
                    height: 80px;
                    line-height: 80px;
                    text-align: center;
                    font-size: 30px;
                    font-weight: bold;
                    color: #000;
                    margin: 40px auto;
                    background: url("../../../assets/adoread/rewadrs/btn_got@2x.png") no-repeat;
                    background-size: 400px 80px;
                    /*img{*/
                    /*    width: 400px;*/
                    /*    height: 80px;*/
                    /*}*/
                }
            }
        }
    }
</style>
